<ng-container *ngIf="isCustom; else customIcon">
    <img [src]="icon" [style]="style" />
</ng-container>
<ng-template #customIcon>
    <fa-icon [icon]="icon" [style]="style" [border]="border"></fa-icon>
</ng-template>
